import type { FeaturedArticlesProps } from '/site/parts/featured-articles/featured-articles.d';

import React, { type JSX } from 'react';
import { formatDate } from '/react4xp/components/DateComponent';
import { Picture } from '/react4xp/components/image/Picture';
import { Anchor } from '/react4xp/components/Element';


export function FeaturedArticles(props: FeaturedArticlesProps): JSX.Element {
	const {
		articleCards,
		title,
	} = props;

	return (
		<section className="py-xl tablet:py-xxxl">
			<div className="flex flex-col gap-md tablet:gap-xl">
				<h2 className="text-xxl font-bold">{title}</h2>
				{
					articleCards
						? <div className="grid grid-cols-1 tablet:grid-cols-2 desktop:grid-cols-3 gap-md tablet:gap-xl">
							{
								articleCards.map((card, index) => {
									if (!card) {
										return null;
									}
									const {
										picture,
										publishedDate,
										title,
										text,
										url,
									} = card;
									return (
										<Anchor
											key={index}
											href={url}
											className={[
												'bg-surface-action-menu',
												'border-none',
												'duration-300',
												'ease-in-out',
												'flex-row',
												'flex',
												'gap-0',
												'no-underline',
												'overflow-hidden',
												'p-0',
												'rounded-sm',
												'text-[var(--design-color-text-menu-default)]',
												'transition',
												'w-full',

												// Didn't help with subpixel problem :(
												// 'will-change-transform',

												// Active:
												'active:bg-surface-action-menu-active',
												'active:ring',
												'active:ring-[var(--design-border-md)]',
												'active:ring-[var(--design-color-border-action-hover)]',
												// Hover:
												'hover:bg-surface-action-menu-hover',
												'hover:ring',
												'hover:ring-[var(--design-border-md)]',
												'hover:ring-[var(--design-color-border-action-hover)]',
												// Tablet:
												'tablet:flex-col',
												'tablet:max-w-[400px]',
											]}
										>
											<Picture
												alt={picture?.alt}
												aria-hidden="true"
												className={[
													'aspect-video',
													'h-full',
													'object-cover',
													'w-[80px]',

													// When the viewport has an odd number of pixels
													// and the parent anchor is in hover or active,
													// there appears a 1px white "gap" under the
													// picture on mobile, and to the right of the
													// picture on tabletUp.
													'scale-y-[1.03]',
													'tranform',
													'tablet:scale-x-[1.005]',
													'tablet:scale-y-100', // Only x on tabletUp

													'tablet:h-[230px]',
													'tablet:w-auto',
												]}
												draggable={false}
												imgProps={{
													loading: 'eager',
												}}
												src={picture?.src}
												sources={picture?.sources}
											/>
											<div className="basis-[content] flex flex-col flex-grow w-full gap-xs p-md">
												<h3 className="text-lg tablet:text-xxl font-bold">{title}</h3>
												<p className="text-md">{publishedDate ? formatDate(publishedDate) : null}</p>
												<p className="hidden tablet:block text-lg">{text}</p>
												<svg
													className="hidden tablet:block shrink-0 mt-auto ml-auto"
													fill="none"
													height="21"
													viewBox="0 0 20 21"
													width="20"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M19.7989 11.4065L12.3799 19.2724C12.2458 19.4512 12.0223 19.4959 11.8436 19.4959C11.6648 19.4959 11.486 19.4512 11.352 19.3171C11.0391 19.0489 11.0391 18.602 11.3073 18.3338L17.5642 11.6299H0.715084C0.312849 11.6299 0 11.3171 0 10.9595C0 10.602 0.312849 10.1998 0.715084 10.1998H17.5642L11.3073 3.54054C11.0391 3.27239 11.0391 2.82546 11.352 2.5573C11.6648 2.28915 12.1117 2.28915 12.3799 2.602L19.7989 10.4679C20.067 10.7361 20.067 11.1383 19.7989 11.4065Z"
														fill="#003057"
													/>
												</svg>
											</div>
										</Anchor>
									);
								})
							}
						</div>
						: null
				}
			</div>
		</section>
	);
}
